import { Component, OnInit, signal, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';

import { QrApiService } from 'src/app/service/qr/qr-api.service';
import { DateFormatPipe } from 'src/app/utils/date-format.pipe';

@Component({
  selector: 'app-qr-illegalclaim',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DateFormatPipe,
  ],
  templateUrl: './qr-illegalclaim.component.html',
  styleUrl: './qr-illegalclaim.component.css',
})
export class QrIllegalclaimComponent implements OnInit {
  // ─── Modern Services Functional Injection Engine ───
  private readonly route = inject(ActivatedRoute);
  private readonly apiService = inject(QrApiService);
  private readonly destroyRef = inject(DestroyRef);

  // ─── Fine-Grained Reactive Signals Architecture ───
  readonly loading = signal<boolean>(false);
  readonly users = signal<any[]>([]);
  readonly textalert = signal<string>('');

  // ─── Strict Component Properties ───
  qrcode: string = '';

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.qrcode = String(routeParams.get('qrcode') || '');
    this.getQrcodeIllegalClaims();
  }

  /**
   * Browser-level clean native backward route jump tracking
   */
  goBack(): void {
    window.history.back();
  }

  /**
   * Pulls structural multi-user fraction logs tied directly to a rogue QR payload
   */
  getQrcodeIllegalClaims(): void {
    if (!this.qrcode) return;

    this.loading.set(true);
    this.apiService
      .getQrcodeillegalclaimHistoryService(this.qrcode)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.loading.set(false))
      )
      .subscribe({
        next: (v) => {
          this.textalert.set(`List of illegal claim customers by QR code: ${this.qrcode}`);
          this.users.set(v?.customerInfoLst || []);
        },
        error: (e) => {
          if (e) alert(e);
        }
      });
  }
}
